import React from 'react'
import AndrewMartinImg from '../../images/speakers/Andrew-Martin.jpg'


const AndrewMartin = () => (
<section id="speaker" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br /><br />
		<div className="row">
        <div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
				<div className="team-wrapper">
					<h2>Andrew Martin</h2>
						<div className="row">
                            <div className="col-md-6">
                                <img src={AndrewMartinImg} className="img-responsive" alt="Andrew Martin" />
                                <ul className="social-icon">
									<li><a href="https://www.linkedin.com/in/andr3wmartin/" target="_blank" className="fa fa-linkedin wow fadeIn"></a></li>
									<li><a href="https://twitter.com/sublimino" target="_blank" className="fa fa-twitter wow fadeIn"></a></li>
								</ul>
                            </div>
                         <div className="col-md-5">
							<p>
                            Andrew has an incisive security engineering ethos gained building and destroying high-traffic web applications. <br />
							Proficient in systems development, testing, and operations, he is comfortable profiling and securing every tier of a bare metal or cloud native system, and has battle-hardened experience delivering containerised solutions to enterprise and government. <br />
							He is a co-founder at <a href="https://control-plane.io" target="_blank">ControlPlane.io</a>
							</p>
                           </div>
                        </div>
                        <div className="row">
							<h4>Talk: In a Container Nobody Hears Your Screams: Next Generation Process Isolation</h4>
							<p>
							Is it ever safe to run untrusted code in containers? Should process isolation keep workloads in, or attackers out? What would it take to run a malware test lab in Kubernetes? 
							<br /><br />
							With fast startup times and consistent execution environments containers beat traditionally slow, monolithic VMs -- but with the advancement of micro VMs the boundaries have become blurred. It is increasingly difficult to know which isolation technology to choose for our next application. Can we run different workloads in different “container” types -- on the same cluster?
							<br /><br />
							In this talk we:<br />
							- examine the history of trying to safely run unsafe processes <br />
							- compare and contrast the emerging generation of process isolation and security techniques<br />
							- rationalise the design decisions that drive each project<br />
							- demo how to break in, out, and learn about what workloads are best suited to run in each technology<br />
							</p>
						</div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default AndrewMartin


// WEBPACK FOOTER //
// ./src/pages/speakers/andrew-martin.js